import { ARTICLES_DATA, ARTICLE_CATEGORY_ORDER } from '../data/articlesData';

export default function ArticlesPage({ setCurrentPage }) {
  const categoryStyles = {
    '手技・処置': { border: 'border-blue-400', dot: 'bg-blue-400' },
    'スケール・評価': { border: 'border-amber-400', dot: 'bg-amber-400' },
    'フィジカルアセスメント': { border: 'border-green-400', dot: 'bg-green-400' },
    '感染対策': { border: 'border-teal-400', dot: 'bg-teal-400' },
    '報告・記録': { border: 'border-indigo-400', dot: 'bg-indigo-400' },
    'コミュニケーション': { border: 'border-purple-400', dot: 'bg-purple-400' },
  };
  const displayCategories = ['手技・処置', 'スケール・評価', 'フィジカルアセスメント', '感染対策', '報告・記録', 'コミュニケーション'];

  // カテゴリ内の表示順は src/data/articlesData.js の ARTICLE_CATEGORY_ORDER で管理
  const categoryOrder = ARTICLE_CATEGORY_ORDER;

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">記事一覧</h1>
      <p className="text-gray-500 text-sm mb-8">臨床に役立つ知識をカテゴリ別にまとめています。</p>
      {displayCategories.map(cat => {
        const order = categoryOrder[cat] || [];
        const articles = ARTICLES_DATA.filter(a => a.category === cat).sort((a, b) => {
          const ai = order.indexOf(a.page);
          const bi = order.indexOf(b.page);
          return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
        });
        const style = categoryStyles[cat];
        return (
          <div key={cat} className="mb-8">
            <h2 className={`text-base font-bold text-gray-800 border-l-4 ${style.border} pl-3 mb-3`}>{cat}</h2>
            <div className="flex flex-wrap gap-x-1 gap-y-1">
              {articles.map((article, i) => (
                <span key={article.id}>
                  <button
                    onClick={() => setCurrentPage(article.page)}
                    className="text-sm text-green-800 hover:text-green-600 hover:underline transition-colors"
                  >
                    {article.shortTitle}
                  </button>
                  {i < articles.length - 1 && <span className="text-gray-300 mx-1">/</span>}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
